import { PricingType } from '@stigg-types/apiTypes';
import { Icons } from '@stigg-components';

export const priceIconByPriceType: Record<PricingType, Icons> = {
  [PricingType.Free]: 'FreePricingType',
  [PricingType.Paid]: 'PaidPricingType',
  [PricingType.Custom]: 'CustomPricingType',
};
